import { render } from "./AskReportView.vue?vue&type=template&id=77d82ac6&scoped=true"
import script from "./AskReportView.vue?vue&type=script&lang=js"
export * from "./AskReportView.vue?vue&type=script&lang=js"

import "./AskReportView.vue?vue&type=style&index=0&id=77d82ac6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d82ac6"]])

export default __exports__